export default __webpack_public_path__ + "static/media/mn.9e1ee95d.svg";